import { endPoints, API_ROOT, API_ROOT_V2 } from "./../../../appSettings";
import { adalApiFetch } from "../../../authProvider";

export const ADD_CONFIG = "ADD_CONFIG";
export const UPDATE_CONFIG = "UPDATE_CONFIG";
export const DELETE_CONFIGURATION = "DELETE_CONFIGURATION";
export const CONFIG_NAME_EXIST = "CONFIG_NAME_EXIST";
export const GET_CONFIGURATION_LIST = "GET_CONFIGURATION_LIST";

export const REMOVE_ELEMENT = "REMOVE_ELEMENT";
export const GET_ELEMENT_PROPERTIES = "GET_ELEMENT_PROPERTIES";
export const GET_FILE_LIST = "GET_FILE_LIST";
export const GET_SUMMARY = "GET_SUMMARY";

export const GET_MATCH_LIST = "GET_MATCH_LIST";
export const ADD_MATCHLIST = "ADD_MATCHLIST";
export const UPDATE_MATCHLIST = "UPDATE_MATCHLIST";
export const DELETE_MATCHLIST = "DELETE_MATCHLIST";

export const GET_VALUES_LIST_BY_ID = "GET_VALUES_LIST_BY_ID";
export const DELETE_VALUES_LIST_VALUE = "DELETE_VALUES_LIST_VALUE";

export const GET_FIELDS = "GET_FIELDS";
export const ADD_FIELD = "ADD_FIELD";
export const UPDATE_FIELD = "UPDATE_FIELD";
export const DELETE_FIELD = "DELETE_FIELD";

export const UPDATE_PRIORITY = "UPDATE_PRIORITY";

export const EXPORT_CONFIGURATION = "EXPORT_CONFIGURATION";
export const IMPORT_CONFIGURATION = "IMPORT_CONFIGURATION";

export const AddConfig = (
  configName,
  fieldToMatch,
  configurations,
  firmwares,
  unitFamilyId,
  unitTypeId,
  unitVersionId,
  isMandatoryUpdate
) => {
  //put arrays into object
  const obj = {
    configName: configName,
    fieldToMatch: fieldToMatch,
    configurations: configurations,
    firmwares: firmwares,
    unitFamilyId: unitFamilyId,
    unitTypeId: unitTypeId,
    unitVersionId: unitVersionId,
    isMandatoryUpdate: isMandatoryUpdate
  };

  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.configurator}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(obj),
      },
      dispatch
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: ADD_CONFIG,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: ADD_CONFIG,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
};

export const UpdateConfig = (
  configId,
  configName,
  fieldToMatch,
  configurations,
  firmwares,
  isMandatoryUpdate,
  releaseHistory
) => {
  //put arrays into object
  const obj = {
    configName: configName,
    fieldToMatch: fieldToMatch,
    configurations: configurations,
    releaseHistory: releaseHistory,
    firmwares: firmwares,
    isMandatoryUpdate: isMandatoryUpdate
  };

  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.configurator}/${configId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(obj),
      },
      dispatch
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: UPDATE_CONFIG,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: UPDATE_CONFIG,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
};

export const CopyConfigV2 = (id, configName) => {
  const obj = {
    id: id,
    configName: configName,
  };

  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT_V2}${endPoints.configurator}/copy`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(obj),
      },
      dispatch
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: UPDATE_CONFIG,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: UPDATE_CONFIG,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
};

export const DeleteConfiguration = (id) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.configurator}/${id}`,
      {
        method: "DELETE",
      },
      dispatch
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: DELETE_CONFIGURATION,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: DELETE_CONFIGURATION,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
};

export const GetElementsProperties = () => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.configurator}/element-properties`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      dispatch
    )
      .then((response) => response.json())
      .then((json) => {
        return dispatch({
          type: GET_ELEMENT_PROPERTIES,
          payload: json,
        });
      });
};

export const GetConfiguration = (id) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.configurator}/${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      dispatch
    ).then((response) =>
      response.json().then((json) => {
        if (!response.ok) {
          return Promise.reject(json);
        }

        return json;
      })
    );
};

export const GetInitialConfiguration = (unitFamily, unitType, unitVersion) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.configurator}/initialdata?unitFamily=${unitFamily}&unitType=${unitType}&unitVersion=${unitVersion}`,
      {
        method: "GET",
      },
      dispatch
    ).then((response) =>
      response.json().then((json) => {
        if (!response.ok) {
          return Promise.reject(json);
        }

        return json;
      })
    );
};

export const GetSummary = (
  configurations,
  firmwares,
  releaseHistory,
  unitFamilyId,
  unitTypeId,
  unitVersionId,
  isMandatoryUpdate,
  configurationId
) => {
  //put arrays into object
  const obj = {
    configurations: configurations,
    firmwares: firmwares,
    releaseHistory: releaseHistory,
    unitFamilyId: unitFamilyId,
    unitTypeId: unitTypeId,
    unitVersionId: unitVersionId,
    isMandatoryUpdate: isMandatoryUpdate,
    configurationId: configurationId
  };

  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.configurator}/summary`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(obj),
      },
      dispatch
    )
      .then((response) => response.json())
      .then((json) => {
        return dispatch({
          type: GET_SUMMARY,
          payload: json,
        });
      });
};

export const GetConfigurationList = (props) => {
  let url = `${API_ROOT}${endPoints.configurator}/list?page=${props.pagination.currentPage}&limit=${props.pagination.pageSize}&orderBy=${props.orderBy}&unitFamily=${props.family}&unitType=${props.type}&unitVersion=${props.version}&searchText=${props.search}`;
  return (dispatch) =>
    adalApiFetch(
      fetch,
      url,
      {
        method: "GET",
      },
      dispatch
    )
      .then((response) => response.json())
      .then((json) => {
        return dispatch({
          type: GET_CONFIGURATION_LIST,
          payload: json,
        });
      });
};

export const IsConfigNameWithFamily = (configName, unitFamilyId) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.configurator}/${configName}/unit-family/${unitFamilyId}/exist`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      dispatch
    )
      .then((response) => response.json())
      .then((json) => {
        return dispatch({
          type: CONFIG_NAME_EXIST,
          isConfigNameExist: json.result,
        });
      });
};

//FieldDefinitions
export const GetFields = () => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.fieldDefinition}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      dispatch
    )
      .then((response) => response.json())
      .then((json) => {
        return dispatch({
          type: GET_FIELDS,
          payload: json,
        });
      });
};

export const AddField = (field) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.fieldDefinition}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(field),
      },
      dispatch
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: ADD_FIELD,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: ADD_FIELD,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
};

export const UpdateField = (field) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.fieldDefinition}/${field.id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(field),
      },
      dispatch
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: UPDATE_FIELD,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: UPDATE_FIELD,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
};

export const DeleteField = (id) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.fieldDefinition}/${id}`,
      {
        method: "Delete",
      },
      dispatch
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: DELETE_FIELD,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: DELETE_FIELD,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
};

export const GetFiles = (props) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.file}/list?page=${props.pagination.currentPage}&limit=${props.pagination.pageSize}&orderBy=${props.orderBy}&searchText=${props.search}&searchBy=${props.searchBy}&operation=${props.operation}&unitFamily=${props.unitFamily}`,
      {
        method: "GET",
      },
      dispatch
    )
      .then((response) => response.json())
      .then((json) => {
        return dispatch({
          type: GET_FILE_LIST,
          payload: json,
        });
      });
};

//GroupValues Api's
export const GetGroupValues = () => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.groupvalues}/list`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      dispatch
    )
      .then((response) => response.json())
      .then((json) => {
        return dispatch({
          type: GET_MATCH_LIST,
          payload: json,
        });
      });
};

export const AddGroupValues = (item, configName) => {
  const url = `${API_ROOT}${endPoints.groupvalues}?configName=${configName}`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(item),
  };

  return async (dispatch) => {
    const response = await adalApiFetch(fetch, url, options, dispatch);
    const json = await response.json();

    if (!response.ok) {
      return dispatch({
        type: ADD_MATCHLIST,
        isSuccess: false,
        payload: json,
      });
    }

    return dispatch({
      type: ADD_MATCHLIST,
      isSuccess: true,
      payload: json,
    });
  };
};

export const UpdateGroupValues = (item, configName) => {
  const url = `${API_ROOT}${endPoints.groupvalues}/${item.id}?configName=${configName}`;
  const options = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(item),
  };

  return async (dispatch) => {
    const response = await adalApiFetch(fetch, url, options, dispatch);
    const json = await response.json();

    if (!response.ok) {
      return dispatch({
        type: UPDATE_MATCHLIST,
        isSuccess: false,
        payload: json,
      });
    }

    return dispatch({
      type: UPDATE_MATCHLIST,
      isSuccess: true,
      payload: json,
    });
  };
};

export const DeleteGroupValues = (id, configName) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.groupvalues}/${id}?configName=${configName}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      },
      dispatch
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: DELETE_MATCHLIST,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: DELETE_MATCHLIST,
            payload: json,
            isSuccess: true,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
};

//ValuesList Api's
export const GetValueslistById = (groupValuesId) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.valueslist}/${groupValuesId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      dispatch
    )
      .then((response) => response.json())
      .then((json) => {
        return dispatch({
          type: GET_VALUES_LIST_BY_ID,
          payload: json,
        });
      });
};

export const GetActivityLogs = (
  startDate,
  endDate,
  page = 1,
  limit = 10,
  sort = 0,
  order = 1,
  search = "",
  activity = 0,
  searchBy = 0,
  operation = 0
) => {
  return (dispatch) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.configurator}${endPoints.activityLogs}?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&sortby=${sort}&orderby=${order}&searchtext=${search}&activity=${activity}&searchby=${searchBy}&operation=${operation}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
      dispatch
    ).then((response) => response.json());
  };
};

export const UpdatePriorityV2 = (configurations, unitFamilyId) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT_V2}${endPoints.configurator}/priority?unitFamilyId=${unitFamilyId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(configurations),
      },
      dispatch
    )
      .then((response) => response.json())
      .then((json) => {
        return dispatch({
          type: UPDATE_PRIORITY,
          payload: json,
          isSuccess: true,
        });
      });
};

export const ExportConfiguration = (configurationId, configurationName) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT_V2}${endPoints.configurator}/export/${configurationId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      dispatch
    ).then((response) => {
      let filename = response.headers
        .get("Content-Disposition")
        .split("filename")[1];
      filename = filename
        .substring(1, filename.length - 2)
        .replace(/^"|"$/g, "");

      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
      });

      return dispatch({
        type: EXPORT_CONFIGURATION,
      });
    });
};

export const ImportConfiguration = (file) => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT_V2}${endPoints.configurator}/import`,
      {
        method: "POST",
        body: file,
      },
      dispatch
    ).then(async (response) => {
      const json = await response.json();

      if (!response.ok) {
        return dispatch({
          type: IMPORT_CONFIGURATION,
          isSuccess: false,
          payload: json,
        });
      }

      return dispatch({
        type: IMPORT_CONFIGURATION,
        isSuccess: true,
        payload: "Success",
      });
    });
};
